import React from 'react';
import Linkify from 'react-linkify';
import { defaultAvatarForUser, formatDate } from 'src/javascripts/services/messageHelpers';
import { ChatMessage, Shop } from 'src/javascripts/shared/chat';

interface Props {
  message: ChatMessage;
  shop: Shop;
}

export default ({ message, shop }: Props) => (
  <div className="received message">
    <div className="avatar-column">
      <a href={`/app/reply/${shop.id}`} target="_blank" className="avatar">
        <img src={defaultAvatarForUser(shop)} alt={`${shop.name} Logo`}/>
      </a>
      <a href={`/app/reply/${shop.id}/${message.id}`} target="_blank" className="reply-button">
        <i className="fas fa-reply"/>
      </a>
    </div>
    <div className="name">{shop.name}</div>
    <div className="content">
      {message.image && <img src={message.image} alt={message.text} onLoad={null}/>}
      <div className="text">
        <Linkify properties={{ target: '_blank', rel: 'noopener nofollow' }}>{message.text}</Linkify>
      </div>
      <div className="time">{formatDate(message.createdAt)}</div>
    </div>
  </div>
);
